import { useEffect, useRef, useState } from "react";

/**
 * Reveals each word of a string with a staggered upward slide.
 * Trigger fires once when the element enters the viewport.
 */
export const WordReveal = ({ text = "", as: Tag = "span", className = "", stagger = 55, testId }) => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) {
      setShown(true);
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setShown(true);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const words = text.split(" ");

  return (
    <Tag
      ref={ref}
      className={`word-reveal ${shown ? "in" : ""} ${className}`.trim()}
      data-testid={testId}
      aria-label={text}
    >
      {words.map((w, i) => (
        <span
          key={i}
          className="w"
          style={{ transitionDelay: `${i * stagger}ms` }}
          aria-hidden="true"
        >
          <span style={{ transitionDelay: `${i * stagger}ms` }}>{w}</span>
          {i < words.length - 1 ? " " : ""}
        </span>
      ))}
    </Tag>
  );
};

export default WordReveal;
